var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M12 19.5q-3.65 0-6.65-2.038T1 12q1.35-3.424 4.35-5.463Q8.35 4.501 12 4.5t6.65 2.037Q21.65 8.576 23 12q-1.35 3.425-4.35 5.462T12 19.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "M12 17.5a9.55 9.55 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 12a9.77 9.77 0 0 0-3.613-4.013A9.55 9.55 0 0 0 12 6.5a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 12a9.77 9.77 0 0 0 3.612 4.012A9.55 9.55 0 0 0 12 17.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M12 7.5q1.29 0 2.313.62a2 2 0 1 0 2.147 3.246q.04.308.04.634 0 1.875-1.313 3.188Q13.875 16.5 12 16.5t-3.188-1.313Q7.502 13.875 7.5 12q0-1.875 1.313-3.188Q10.125 7.502 12 7.5"
}))));
export default SvgViewIcon;